import {
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Stack,
    Typography
} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {CalendarIconSvg} from "../../../constants/icons";
import {DatePicker} from "@mui/x-date-pickers";
import {LoadingButton} from "@mui/lab";
import {DIRECTION_NAME, ROLES_CAN_ISSUE_TICKETS} from "../../../constants";
import B2B from "../B2B";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {searchTripApiV2} from "../../../api/trip";
import {AUTH} from "../../../auth/FirebaseContext";
import {useAuthContext} from "../../../auth/useAuthContext";
import {isWithinTwoHours} from "../../../helper/timeCheck";
import {useSelector} from "../../../redux/store";
import CancelVerificationDialog from "../CancelVerificationDialog";

export default function TripActionButtons({
                                              data,
                                              directionType,
                                              currentTime,
                                              setMakeReservation,
                                              setValue,
                                              getValues,
                                              translate,
                                              enqueueSnackbar,
                                              setShowVerificationDialog,
                                              setShowPlatformDialog,
                                              setShowItinerer,
                                              setLoadingItinerants,
                                              getItinerariesLinkedAPI,
                                              OPERATOR
                                          }) {
    const {control, watch, handleSubmit} = useFormContext();
    const dateFrom = watch("dateFrom");
    const {user} = useAuthContext();
    const {canSellExpiredDepartures, expiredDepartureMinutesLimit} = useSelector(state => state.userSettings);

    const [selectedReturnTrip, setSelectedReturnTrip] = useState()
    const [foundReturnTrips, setFoundReturnTrips] = useState()
    const [loadingReturnTrips, setLoadingReturnTrips] = useState(true)
    const [showCancelVerification, setShowCancelVerification] = useState(false)

    const handleItinerer = () => {
        setLoadingItinerants(true);
        const depStationId = data.depStationId;
        const arrStationId = data.arrStationId;
        getItinerariesLinkedAPI(data.tripId, getValues("dateFrom"), data.linkId)
            .then(({data}) => {
                setShowItinerer({open: true, data, depStationId, arrStationId});
            })
            .catch((reason) => {
                console.error("getItinerariesLinkedAPI", reason);
                enqueueSnackbar(translate("error"), {variant: "error"});
            })
            .finally(() => {
                setLoadingItinerants(false);
            });
    };

    const isTripExpired = () => {
        if (data.canceled) return true;
        const departureTime = moment.tz(data.departureTripTime, "YYYY-MM-DD HH:mm:ss", "Europe/Belgrade");
        const now = moment.tz("Europe/Belgrade");
        if (departureTime.isAfter(now)) return false;
        if (!canSellExpiredDepartures) return true;
        const minutesLimit = expiredDepartureMinutesLimit || 0;
        const minutesSinceDeparture = now.diff(departureTime, 'minutes', true);
        return minutesSinceDeparture > minutesLimit;
    };


    const onSelectedReturnTrip = (e) => {
        const {value} = e.target
        setValue("returnTrip", value)
        setSelectedReturnTrip(value)
    }

    const handleKeyboardPress = e => {
        if (e.ctrlKey && e.key.toLowerCase() === 'c') {
            e.preventDefault();

            handleShowPriceDialog();
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', handleKeyboardPress);
        return () => {
            window.removeEventListener('keydown', handleKeyboardPress)
        }

    }, [])

    const handleShowPriceDialog = () => {
        setValue("showPriceListDialog", {
            open: true,
            showRateCardSelect: false,
            lineId: data.lineId,
            linkId: data?.linkId || null,
            rateCardId: data.rateCardId,
            tripId: data.tripId,
            operatorName: data?.operatorName,
            lineName: data.printText,
            operatorId: data.operatorId,
            editable: false,
            arrStationId: data.arrStationId,
            journeyDate: data.departureTripTime,
            stationId: getValues("startStation")?.id,
        });
    }

    const dateToCheck = moment(data?.departureTripTime);
    const now = moment();

    const isFuture = dateToCheck.isAfter(now, 'day');

    return (
        <div style={{marginTop: 16}}>
            <Stack
                direction="row"
                spacing={2}
                flexWrap="wrap"
                useFlexGap
                alignItems="center"
            >
                <Button
                    sx={{width: 170, height: 80}}
                    color="primary"
                    variant="outlined"
                    disabled={data.externalSale || isTripExpired() || (!isFuture && isWithinTwoHours(data.departureTripTime))}
                    onClick={() => {
                        setMakeReservation(true);
                        setValue("reservationData", data);
                    }}
                >
                    Rezervacija [F6]
                </Button>

                {ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group) && directionType === DIRECTION_NAME[0] && (
                    <Button
                        sx={{width: 170, height: 80}}
                        color="primary"
                        variant="outlined"
                        disabled={data.externalSale || isTripExpired()}
                        onClick={() => {
                            setShowVerificationDialog({open: true, data});
                        }}
                    >
                        Overa [F4]
                    </Button>
                )}

                {/* Poništavanje radi samo nad overom bez fiskalnog računa, pa se dugme i prikazuje
                    samo operaterima koji tako overavaju. Traži se po broju karte, ne po polasku. */}
                {user?.verifyWithoutFiscal && ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group) && directionType === DIRECTION_NAME[0] && (
                    <Button
                        sx={{width: 170, height: 80}}
                        color="error"
                        variant="outlined"
                        onClick={() => setShowCancelVerification(true)}
                    >
                        Poništi overu
                    </Button>
                )}

                {ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group) &&  <Button
                    sx={{width: 170, height: 80}}
                    color="primary"
                    variant="outlined"
                    disabled={isFuture}
                    onClick={() => setShowPlatformDialog(true)}
                >
                    Peronska karta
                </Button>}

                <Button
                    sx={{width: 170, height: 80}}
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                        if (getValues("startStation")?.id && getValues("endStation")) {
                            setValue("showInfoDialog", {
                                open: true,
                                data: {
                                    operatorId: data?.operatorId,
                                    arrivalStationName: data?.depStationName,
                                    depStationId: getValues("startStation")?.id,
                                    arrStationId: getValues("endStation").id,
                                    dateFrom: moment(getValues("dateFrom")).format("YYYY-MM-DD"),
                                    toLocationId: null,
                                    isIndividual: true
                                }
                            });
                        } else {
                            enqueueSnackbar("Morate izabrati stanicu do", {variant: "info"});
                        }
                    }}
                >
                    Povratak iz mesta
                </Button>

                <Button
                    sx={{width: 170, height: 80}}
                    color="primary"
                    variant="outlined"
                    onClick={handleShowPriceDialog}
                >
                    Cenovnik
                </Button>

                <LoadingButton
                    loading={false}
                    sx={{width: 170, height: 80}}
                    disabled={data.externalSale}
                    color="primary"
                    variant="outlined"
                    onClick={handleItinerer}
                >
                    Itinerer
                </LoadingButton>
                <Stack direction="row" spacing={1} justifyContent="center">
                    {data.requiresReturnDate &&
                        directionType === DIRECTION_NAME[1] &&
                        (
                            <Controller
                                name="returnDate"
                                control={control}
                                render={({field, fieldState: {error}}) => (
                                    <DatePicker
                                        {...field}
                                        views={['year', 'month', 'day']}
                                        minDate={dateFrom}
                                        onChange={(newValue) => {
                                            searchTripApiV2({
                                                departureStationId: data?.arrStationId,
                                                arrivalStationId: data?.depStationId,
                                                from: moment(newValue).startOf('day').format("YYYY-MM-DD"),
                                                to: moment(newValue).add(1,'days').startOf('day').format("YYYY-MM-DD"),
                                                opId: user.id,
                                                showWithoutRate :false
                                            }).then(({data}) => {
                                                setFoundReturnTrips(data)
                                            }).catch(e => {
                                                console.error(e, "searchTripApiV2")
                                            }).finally(() => {
                                                setLoadingReturnTrips(false)
                                            })
                                            setValue("returnDate", moment(newValue, "DD.MM.YYYY")
                                                .startOf('day')
                                                .utc(true)
                                                .toDate())
                                        }}
                                        label={translate("returnDate")}
                                        inputFormat="dd/MM/yyyy"
                                        slotProps={{textField: {size: "small"}}}
                                        slots={{openPickerIcon: CalendarIconSvg}}
                                    />
                                )}
                            />
                        )}
                    {data.requiresReturnDate && directionType === DIRECTION_NAME[1] && (
                        <FormControl size="small" sx={{width: {xs: 1, md: 250}, mb: 2}}>
                            <InputLabel sx={{'&.Mui-focused': {color: 'text.primary'}}}>Povratak</InputLabel>
                            <Select
                                onChange={onSelectedReturnTrip}
                                value={selectedReturnTrip}
                                input={<OutlinedInput label="Povratak"/>}
                                IconComponent={loadingReturnTrips ? () => <CircularProgress size={16}/> : undefined}
                                disabled={loadingReturnTrips}
                            >
                                {loadingReturnTrips ? (
                                    <MenuItem disabled>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <CircularProgress size={16}/>
                                            <Typography variant="body2">Učitavanje…</Typography>
                                        </Stack>
                                    </MenuItem>
                                ) : (
                                    foundReturnTrips?.map((option) => (
                                        <MenuItem
                                            key={option.tripId}
                                            value={option}
                                            sx={{
                                                p: 1,
                                                mx: 1,
                                                my: 0.5,
                                                borderRadius: 0.75,
                                                typography: 'body2',
                                                '&:first-of-type': {mt: 0},
                                                '&:last-of-type': {mb: 0},
                                            }}
                                        >
                                            {moment(option.departureTime).format('HH:mm')}
                                        </MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    )}

                </Stack>

                {ROLES_CAN_ISSUE_TICKETS.includes(OPERATOR.group) && <B2B/>}
            </Stack>

            {user?.verifyWithoutFiscal && (
                <CancelVerificationDialog
                    open={showCancelVerification}
                    onClose={() => setShowCancelVerification(false)}
                />
            )}
        </div>
    );
}
